import { Component, Inject, OnDestroy } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { UserValidationRequest } from 'src/app/models/UserValidationRequest.model';
import { UserValidationResult } from 'src/app/models/UserValidationResult.model';
import { RequestService } from 'src/app/services/request.service';
import { Md5 } from 'ts-md5';

@Component({
  selector: 'app-usermanagement-list-override-password',
  templateUrl: './usermanagement-list-override-password.component.html',
  styleUrls: ['./usermanagement-list-override-password.component.scss']
})
export class UsermanagementListOverridePasswordComponent implements OnDestroy {
  form: FormGroup;
  errors: string[] = [];
  button1: string = "Cancel";
  button2: string = "Override";
  title: string = "Override Password";
  isPasswordVisible: boolean = false;
  isPasswordRepeatVisible: boolean = false;
  private unscubscribe$ = new Subject<void>();

  constructor(
    private requestService: RequestService,
    private dialogRef: MatDialogRef<UsermanagementListOverridePasswordComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { email: string }) {
    this.form = new FormGroup({
      password: new FormControl(null, Validators.required),
      passwordRepeat: new FormControl(null, Validators.required),
    });
    this.dialogRef.disableClose = true;
  }

  overridePassword() {
    var password = this.form.get('password').value;
    var repeatPassword = this.form.get('passwordRepeat').value;

    let userValidationRequest: UserValidationRequest = {
      email: null,
      password: password,
      repeatPassword: repeatPassword,
      companyId: -1
    };

    this.requestService.validateUser(userValidationRequest).pipe(takeUntil(this.unscubscribe$))
      .subscribe((response: UserValidationResult) => {
        if (response.success) {
          const md5 = new Md5();
          let hashedPw: string = md5.appendStr(password).end().toString();

          this.dialogRef.close({ save: true, data: { password: hashedPw, email: this.data.email } });
        }
        else {
          this.errors = response.errors;
        }
      });
  }

  visibilityPassword() {
    this.isPasswordVisible = !this.isPasswordVisible;
  }

  visibilityPasswordRepeat() {
    this.isPasswordRepeatVisible = !this.isPasswordRepeatVisible;
  }

  cancel() {
    this.dialogRef.close({ save: false, data: null });
  }

  ngOnDestroy(): void {
    this.unscubscribe$.next();
    this.unscubscribe$.complete();
  }
}
